// pages/Work/works/GreenPlatterApp.js
import React from "react";
import Login from "../../../assets/GP_APP/GP_App_1.png";
import GPapp2 from "../../../assets/GP_APP/GP_App_2.png";
import GPapp3 from "../../../assets/GP_APP/GP_App_3.png";
import GPapp4 from "../../../assets/GP_APP/GP_App_4.png";
import GPapp5 from "../../../assets/GP_APP/GP_App_5.png";

const GreenPlatterApp = () => {
  return (
    <div className="pt-16 mx-3 md:mx-8">
      <h1 className="text-4xl mb-8 font-black text-lightBrown md:text-6xl md:mb-16 ">
        GreenPlatter iOS App
      </h1>
      {/* <p>
        GreenPlatter is an AI-powered platform that empowers diabetic patients
        by providing real-time, personalized meal plans tailored to their blood
        glucose levels, acting as a dietician in their pocket.
      </p> */}
      <div className="mx-4 md:mx-0">
        {/*---------------------------- mobile view table  ----------------------------*/}
        <table
          className="md:hidden mx-2 my-4 text-sm"
          style={{ borderSpacing: "1 0" }}
        >
          <tbody>
            <tr>
              <td className=" p-1 align-top w-1/2">
                <h2 className="font-bold underline">ROLE</h2>
                <p> Front-End Software Engineer Intern</p>
              </td>
              <td className=" p-1 align-top w-1/2">
                <h2 className="underline font-bold ">RESPONSIBILITIES</h2>
                <p>
                  Developed cross-platform mobile applications using React
                  Native, focusing on responsive UI design with Tailwind CSS,
                  and optimized user experience
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        {/* -------------------------------project overview */}
        <div className=" flex flex-col mb:mb-4 md:flex-row md:mx-10">
          <img
            src={Login}
            alt="GP1"
            className=" rounded-xl object-contain w-full max-w-full h-auto  md:w-1/3 md:h-auto "
          />
          <div className="md:flex md:items-center">
            <div>
              <p className="text-center py-4 text-lg md:pl-8  md:text-2xl">
                GreenPlatter is an AI-powered platform that empowers diabetic
                patients by providing real-time, personalized meal plans
                tailored to their blood glucose levels, acting as a dietician in
                their pocket.
              </p>
              <p className="text-center py-4 text-lg md:pl-8  md:text-2xl">
                {" "}
                Developed cross-platform mobile applications using React Native.
                Built responsive user interfaces with Tailwind CSS.
              </p>
            </div>
          </div>
        </div>

        {/*---------------------------- desktop view table ----------------------------*/}
        <table
          className="hidden md:block border-separate mx-[8%] my-16 "
          style={{ borderSpacing: "6rem 0" }}
        >
          <tbody>
            <tr>
              <td className="p-4 text-lg align-top w-1/2">
                <h2 className="font-bold text-xl underline">ROLE</h2>
                <p> Front-End Software Engineer Intern</p>
              </td>
              <td className=" p-4 text-lg align-top w-1/2">
                <h2 className="underline font-bold text-xl">
                  RESPONSIBILITIES
                </h2>
                <p>
                  Developed cross-platform mobile applications using React
                  Native, focusing on responsive UI design with Tailwind CSS,
                  and optimized user experience
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        {/*---------------------------- screenshots of projects ----------------------------*/}
        <div>
          <h2 className="text-pink font-bold  text-center pb-4 text-xl md:text-2xl">
            {" "}
            - - Website Snapshot - -
          </h2>
          <div className="flex flex-col md:flex-row flex-wrap justify-center gap-4">
            {" "}
            <img
              src={GPapp5}
              alt="GP app5"
              className="mb-2 rounded-xl mx-auto max-w-full h-auto md:mb-8 md:w-1/3"
            />
            <img
              src={GPapp2}
              alt="GP app2"
              className="mb-8 rounded-xl mx-auto max-w-full h-auto md:w-1/3"
            />
            {/* <div className="md:flex md:items-center md:w-1/2">
              {" "}
              <p className=" mb-4 pb-4 text-base px-2 md:text-xl md:mr-32">
                {" "}
                Design and development of a promotional website using HTML and
                CSS were undertaken to effectively showcase GreenPlatter's
                innovative solutions and enhance its connection with the target
                audience.
              </p>
            </div> */}
          </div>
          <div className="flex flex-col md:flex-row flex-wrap justify-center gap-4">
            {" "}
            <img
              src={GPapp3}
              alt="GP app4"
              className="mb-8 rounded-xl mx-auto max-w-full h-auto md:w-1/3"
            />
            <img
              src={GPapp4}
              alt="GP app4"
              className="mb-8 rounded-xl mx-auto max-w-full h-auto md:w-1/3"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default GreenPlatterApp;
